<template>
	<div class="root">
		<a class="consult-button" href="javascript:void(0);" @click="getConsultPop"></a>
		<div v-show="showConsult" class="consult-mask" @click="closeMask($event)">
			<div class="consult-pop" ref="mask"></div>
		</div>
		<div class="banner-box">
			<div class="banner">
				<div class="content">
					<a href="/"></a>
					<div class="tab-box">
						<div class="tabs tab-left" :class="{'active':tabFlag}" @click="tabFlag = true">
							企业经营贷
							<i v-show="tabFlag"></i>
						</div>
						<div class="tabs tab-right" :class="{'active':!tabFlag}" @click="tabFlag = false">
							知识产权质押贷
							<i v-show="!tabFlag"></i>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="business-loan" v-show="tabFlag">
			<div class="green-channel">
				<div class="channel-content">
					<i class="map"></i>
					<div class="word">
						<img src="./financing/word-green.png" alt="">
						<img src="./financing/green-channel.png" alt="">
						<img class="has-padding" src="./financing/icon-blue-orange.png" alt="">
					</div>
					<ul class="channel-detail">
						<li class="first">
							<p>三大行业</p>
							<p>特事特办</p>
							<p>利率补贴</p>
						</li>
						<li class="second">
							<img src="./financing/word-health.png" alt="">
						</li>
						<li class="third">
							<img class="top" src="./financing/word-medical.png" alt="">
							<img class="mid" src="./financing/word-mask.png" alt="">
							<img class="bottom" src="./financing/word-disinfect.png" alt="">
						</li>
						<li class="fourth">
							<img src="./financing/word-medicine.png" alt="">
						</li>
					</ul>
				</div>
			</div>
			<div class="all-help">
					<div class="help-content">
						<div class="word">
							<img src="./financing/word-help.png" alt="">
							<img src="./financing/universal-support.png" alt="">
							<img class="has-padding" src="./financing/icon-blue-orange.png" alt="">
						</div>
						<ul class="help-detail">
							<li class="first">
								<p>所有企业</p>
								<p>均可享受</p>
							</li>
							<li class="second">
								<div class="up">
									<h2>免费服务</h2>
									<span>专业咨询免费提供</span>
								</div>
								<div class="down">
									<h2>线上咨询</h2>
									<span>微信关注公众号</span>
									<span>起点分期ZBJ</span>
								</div>
							</li>
							<li class="third">
								<div class="up">
									<h2>专属福利</h2>
									<span>简化审批流程、降低融资成本</span>
								</div>
								<div class="down">
									<h2>精准帮扶</h2>
									<span>多种贷款产品</span>
									<span>精准满足需求</span>
								</div>
							</li>
						</ul>
					</div>
			</div>
			<div class="all-together">
				<div class="together-detail">
					<div class="title-en">同舟共济</div>
					<div class="subheading">
						<h2>16</h2>
						<span>家银行战略合作</span>
						<img src="./financing/blue-line.png" alt="">
						<span>为您竭诚服务</span>
					</div>
					<div class="banks"></div>
				</div>
			</div>
			<div class="contact-us">
				<div class="contact-detail">
					<div class="title-en">更多联系方式</div>
					<div class="line">
						<img src="./financing/blue-orange.png" alt="">
					</div>
					<ul class="more-detail">
						<li class="left">
							<p>微信咨询</p>
							<img src="./financing/erweima-business.png" alt="">
						</li>
						<li class="middle">
							<p>联系电话</p>
							<img src="./financing/gray-line.png" alt="">
							<h2>153 1091 6825</h2>
						</li>
						<li class="right">
							<p>电子邮箱</p>
							<img src="./financing/gray-line.png" alt="">
							<h2>liqilan@zbj.com</h2>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="pledge-loan" v-show="!tabFlag">
			<div class="high-tech">
				<div class="tech-detail">
					<div class="blue-part">
						<h2>高新企业办理更方便</h2>
						<span></span>
						<p><strong>·</strong><i>质押品种多</i> </p>
						<p><strong>·</strong><i>融资成本低</i></p>
					</div>
					<div class="white-part">
						<ul class="tech-item">
							<li class="item-icon">
								<img src="./financing/icon-quota.png" alt="">
							</li>
							<li class="text">
								<h2>额度够高</h2>
								<p>可贷300-1000万</p>
							</li>
						</ul>
						<ul class="tech-item">
							<li class="item-icon">
								<img src="./financing/icon-server.png" alt="">
							</li>
							<li class="text">
								<h2>服务放心</h2>
								<p>科素中心全流程支持</p>
							</li>
						</ul>
						<ul class="tech-item">
							<li class="item-icon">
								<img src="./financing/icon-rate.png" alt="">
							</li>
							<li class="text">
								<h2>利率够低</h2>
								<p>年利率不超过8%</p>
							</li>
						</ul>
						<ul class="tech-item">
							<li class="item-icon">
								<img src="./financing/icon-pledge.png" alt="">
							</li>
							<li class="text">
								<h2>多种质押</h2>
								<p>专利、商标、著作权均可</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="bank-cooperate">
				<div class="cooperate-detail">
					<ul class="title">
						<li class="left"></li>
						<li class="mid">重庆科技要素交易中心携手五大银行联合推出</li>
						<li class="right"></li>
					</ul>
					<ul class="banks-box">
						<li class="bottom-margin">
							<img src="./financing/bank-CEB.png" alt="">
						</li>
						<li class="bottom-margin has-margin">
							<img src="./financing/bank-hankou.png" alt="">
						</li>
						<li class="bottom-margin">
							<img src="./financing/bank-xingye.png" alt="">
						</li>
						<li><img src="./financing/bank-SPD.png" alt=""></li>
						<li class="has-margin">
							<img src="./financing/bank-CCF.png" alt="">
						</li>
					</ul>
				</div>
			</div>
			<div class="procedure">
				<div class="procedure-detail">
					<div class="title-en">办理流程</div>
					<div class="line">
						<img src="./financing/blue-orange.png" alt="">
					</div>
					<ul class="process-map">
						<li class="item left">
							<img src="./financing/icon-form.png" alt="">
							<p class="top">填写表单</p>
							<p>邮件发送申请</p>
						</li>
						<li class="arrow">
							<img src="./financing/arrow-right.png" alt="">
						</li>
						<li class="item">
							<img src="./financing/icon-tech.png" alt="">
							<p class="top">科素中心</p>
							<p>上门服务</p>
						</li>
						<li class="arrow">
							<img src="./financing/arrow-right.png" alt="">
						</li>
						<li class="item">
							<img src="./financing/icon-loan.png" alt="">
							<p class="top">对接金融机构</p>
							<p>协助完成贷款</p>
						</li>
					</ul>
					<a class="down-load" target="_blank" href="//cdn.zbjddd.com/知识产权质押融资申请表.doc">立即下载</a>
				</div>
			</div>
			<div class="contact-us">
				<div class="contact-detail">
					<div class="title-en">更多联系方式</div>
					<div class="line">
						<img src="./financing/blue-orange.png" alt="">
					</div>
					<ul class="more-detail">
						<li class="left">
							<p>微信咨询</p>
							<img src="./financing/erweima-pledge.png" alt="">
						</li>
						<li class="middle">
							<p>办理咨询</p>
							<span></span>
							<h2>186 8144 2187</h2>
						</li>
						<li class="right">
							<p>电子邮箱</p>
							<span></span>
							<h2>yangqian@zbj.com</h2>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'financing',
	data () {
		return {
			tabFlag: true,
			showConsult: false,
		}
	},
	mounted() {
		this.$bus.$emit('ready');
	},
	methods: {
		getConsultPop () {
			this.showConsult = true;
		},
		closeMask (e) {
			if(!this.$refs.mask.contains(e.target)) {
				this.showConsult = false;
			}
		}
	}
}
</script>
<style lang="less" scoped>
@import "..\..\..\global\css\mixin\mixin.less";
.consult-button{
	position: fixed;
	width: 81px;
	height: 231px;
	background: url('./financing/bg-consult.png') no-repeat;
	right: 10px;
	top: 50%;
	margin-top: -115px;
	z-index: 1000;
}
.consult-mask{
	position: fixed;
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
	background-color: rgba(45, 46, 46, 0.6);
	z-index: 1001;
	.consult-pop{
		position: absolute;
		width: 638px;
		height: 277px;
		background: url('./financing/consult-pop.png') no-repeat;
		left: 50%;
		margin-left: -319px;
		top: 50%;
		margin-top: -160px;
	}
}
.banner-box{
	position: relative;
	width: 100%;
	height: 1000px;
	min-width: 1182px;
	.banner{
	width: 100%;
	height: 1057px;
	background: url('./financing/fina-banner.png') no-repeat center top;
	position: absolute;
	top:0px;
	.content{
		width: 1182px;
		height: 1057px;
		margin: 0 auto;
		position: relative;
		a{
			width: 176px;
			height: 55px;
			position: absolute;
			top: 20px;
			left: 0px;
			background: url('./financing/fina-logo.png') no-repeat;
		}
		.tab-box{
			position: absolute;
			width: 1182px;
			margin-left:-591px;
			left: 50%;
			top: 718px;
			height: 140px;
			box-shadow: 0px 3px 32px 0px rgba(158,181,237,0.29), 0px 3px 46px 0px rgba(160,180,249,0.42);
			.tabs{
				width: 591px;
				height: 140px;
				position: absolute;
				top:0px;
				background-color: #fff;
				line-height: 140px;
				text-align: center;
				font-size: 32px;
				color: #333333;
				cursor: pointer;
				&.tab-left{
					left: 0px;
				}
				&.tab-right{
					left: 591px;
				}
				i{
					position: absolute;
					width: 82px;
					height: 82px;
					background:url('./financing/fina-tabs.png') no-repeat;
					left: 265px;
					bottom: -48px;
				}
				&.active{
					color: #ffffff;
					background-color: #0587FF;
				}
			}
		}
	}
}
}
.business-loan{
	padding-top:70px;
	.green-channel{
		width: 100%;
		height: 683px;
		background-color: #ffffff;
		.channel-content{
			width: 1182px;
			height: 683px;
			margin: 0 auto;
			position: relative;
			i{
				position: absolute;
				width: 1182px;
				height: 683px;
				background: url('./financing/map-wuhan.png') no-repeat center;
				top: 0px;
				left: 240px;
			}
			.word{
				padding-top: 20px;
				img{
					display: block;
					margin-bottom: 10px;
					&.has-padding{
						padding-top: 10px;
					}
				}
			}
			.channel-detail{
				width: 1182px;
				height: 328px;
				position: relative;
				li{
					width: 330px;
					height: 328px;
					float: left;
					text-align: center;
					&.first{
						width: 192px;
						p{
							padding-left: 30px;
							height: 75px;
							line-height: 75px;
							text-align: left;
							font-size: 20px;
							color: #333333;
							background: url('./financing/icon-heart.png') no-repeat left center;
						}
					}
					&.second{
						background: url('./financing/bg-health.png') no-repeat center;
						line-height: 348px;
					}
					&.third{
						background: url('./financing/bg-medical.png') no-repeat center;
						img{
							display: block;
							margin: 0 auto;
							&.top{
								margin-top: 80px;
							}
							&.mid{
								margin-top: 20px;
							}
						}
					}
					&.fourth{
						background: url('./financing/bg-medicine.png') no-repeat center;
						line-height: 348px;
					}
				}
			}
		}
	}
	.all-help{
		width: 100%;
		height: 657px;
		background-color: #f7f7f7;
		.help-content{
			width: 1182px;
			margin: 0 auto;
			padding-top: 70px;
			.word{
				img{
					display: block;
					margin-bottom: 10px;
					&.has-padding{
						padding-top: 10px;
					}
				}
			}
			.help-detail{
				width: 1182px;
				height: 330px;
				position: relative;
				li{
					height: 330px;
					width: 450px;
					float: left;
					&.first{
						width: 252px;
						height: 320px;
						padding-left: 30px;
						padding-top: 10px;
						font-size: 20px;
						color: #333333;
						background: url('./financing/icon-heart.png') no-repeat left top 16px;
						p{
							height: 30px;
							line-height: 30px;
						};
					}
					&.second,&.third{
						.up{
							width: 280px;
							height: 133px;
							padding-left:170px;
							margin-bottom: 55px; 
							background: url('./financing/icon-service.png') no-repeat left center;
							h2{
								font-size: 32px;
								color: #333333;
								padding-top:15px;
								line-height: 55px;
								font-weight: 800;
							}
							span{
								display: block;
								font-size: 18px;
								line-height: 45px;
								color: #666666;
							}
						}
						.down{
							width: 280px;
							height: 133px;
							padding-left:170px; 
							background: url('./financing/icon-online.png') no-repeat left center;
							h2{
								font-size: 32px;
								color: #333333;
								padding-top:5px;
								line-height: 50px;
								font-weight: 800;
							}
							span{
								display: block;
								font-size: 18px;
								line-height: 35px;
								color: #666666;
							}
						}
					}
					&.third{
						.up{
							background: url('./financing/icon-exclusive.png') no-repeat left center;
						}
						.down{
							background: url('./financing/icon-help.png') no-repeat left center;
						}
					}
				}
			}
		}
	}
	.all-together{
		width: 100%;
		height: 976px;
		background-color: #ffffff;
		.together-detail{
			width: 1182px;
			height: 870px;
			padding-top: 106px;
			margin: 0 auto;
			.title-en{
				width: 1182px;
				height: 60px;
				padding-top: 34px;
				background: url('./financing/all-together.png') no-repeat center;
				text-align: center;
				font-size: 55px;
				font-weight: 800;
			}
			.subheading{
				width: 100%;
				height: 90px;
				text-align: center;
				display: flex;
				align-items: center;
				justify-content: center;
				span{
					font-size: 30px;
					color: #333333;
				}
				h2{
					font-size: 30px;
					color: #FF6A00;
					letter-spacing: 5px;
				}
				img{
					padding: 0px 20px;
				}
			}
			.banks{
				width: 1182px;
				height: 686px;
				background: url('./financing/banks.png') no-repeat center;
			}
		}
	}
	.contact-us{
		width: 100%;
		height: 644px;
		background-color: #f7f7f7;
		.contact-detail{
			width: 1182px;
			height: 520px;
			padding-top: 124px;
			margin: 0 auto;
			.title-en{
				width: 1182px;
				height: 60px;
				padding-top: 34px;
				background: url('./financing/contact-us.png') no-repeat center;
				text-align: center;
				font-size: 55px;
				font-weight: 800;
			}
			.line{
				text-align: center;
				padding-top: 20px;
			}
			.more-detail{
				width: 1182px;
				height: 218px;
				padding-top: 42px;
				li{
					width: 340px;
					height: 218px;
					float: left;
					background-color: #ffffff;
					&.left{
						text-align: center;
						font-size: 24px;
						color: #333333;
						p{
							padding-top: 35px;
							padding-bottom: 18px;
						}
						img{
							display: inline-block;
							width: 110px;
							height: 110px;
						}
					}
					&.middle{
						margin:0 81px;
					}
					&.middle,&.right{
						padding-left: 60px;
						width: 280px;
						p{
							font-size: 24px;
							color: #333333;
							padding-top: 32px;
							padding-bottom: 12px;
						}
						h2{
							font-size: 24px;
							color: #333333;
							padding-top: 52px;
						}
						img{
							margin-left:2px;
						}
					}
				}
			}
		}
	}
}
.pledge-loan{
	padding-top: 30px;
	.high-tech{
		width: 100%;
		height: 564px;
		background-color: #fdfdfd;
		.tech-detail{
			position: relative;
			width: 1182px;
			height: 564px;
			margin: 0 auto;
			.blue-part{
				width: 1120px;
				height: 413px;
				position: absolute;
				background: url('./financing/bg-high-tech.png') no-repeat;
				left: 0px;
				top: 0px;
				padding-left: 25px;
				h2{
					color: #ffffff;
					font-size: 34px;
					padding-top: 90px;
				}
				span{
					display: block;
					width: 30px;
					height: 4px;
					background-color: #ffffff;
					margin-top: 24px;
					margin-left: 2px;
					margin-bottom: 20px;
				}
				p{
					color: #ffffff;
					font-size: 24px;
					height: 60px;
					strong{
						font-size: 40px;
						float: left;
						line-height: 60px;
					}
					i{
						float: left;
						line-height: 60px;
					}
				}
			}
			.white-part{
				width: 640px;
				height: 240px;
				position: absolute;
				left: 340px;
				top: 40px;
				padding: 78px 100px;
				background-color: #ffffff;
				box-shadow:0px 3px 46px 0px rgba(158,181,237,0.51);
				.tech-item{
					width: 320px;
					height: 120px;
					float: left;
					li{
						float: left;
						height: 120px;
					}
					.item-icon{
						width: 90px;
						display: flex;
						align-items: center;
						justify-content: flex-end;
					}
					.text{
						margin-left: 30px;
						h2{
							color: #333333;
							font-size: 22px;
							height: 40px;
							line-height: 40px;
							padding-top: 30px;
							font-weight: 900;
						}
						p{
							color: #333333;
							font-size: 18px;
							height: 30px;
							line-height: 30px;
						}
					}
				}
			}
		}
	}
	.bank-cooperate{
		width: 100%;
		height: 1084px;
		background-color: #ffffff;
		.cooperate-detail{
			width: 1182px;
			padding-top: 64px;
			height: 1020px;
			margin: 0 auto;
			.title{
				width: 1086px;
				height: 110px;
				li{
					float: left;
					height: 110px;
					&.left{
						width: 146px;
						background: url('./financing/point-left.png') no-repeat center;
					}
					&.mid{
						width: 794px;
						text-align: center;
						line-height: 110px;
						color: #464C5D;
						font-weight: 900;
						font-size: 36px;
						background: url('./financing/blue-orange.png') no-repeat center bottom;
					}
					&.right{
						width: 146px;
						background: url('./financing/point-right.png') no-repeat center;
					}
				}
			}
			.banks-box{
				width: 1182px;
				height: 674px;
				padding: 100px 0;
				li{
					box-sizing: border-box;
					width: 342px;
					height: 314px;
					border: 2px solid #E9E9E9;
					float: left;
					position: relative;
					cursor: pointer;
					&.has-margin{
						margin: 0px 78px;
					}
					&.bottom-margin{
						margin-bottom: 46px;
					}
					img{
						position: absolute;
						width: 214px;
						height:214px;
						top: 50px;
						left: 64px;
						-webkit-transition: -webkit-transform 0.3s;
						-moz-transition: -moz-transform 0.3s;
						-o-transition: -o-transform 0.3s;
						transition: transform 0.3s;
					}
					&:hover{
						border: 2px solid #0587FF;
						img{
							-webkit-transform: translateY(-40px);
							-moz-transform: translateY(-40px);
							-ms-transform: translateY(-40px);
							-o-transform: translateY(-40px);
							transform: translateY(-40px);
						}
					}
				}
			}
		}
	}
	.procedure{
		width: 100%;
		height: 706px;
		background-color: #fafafa;
		.procedure-detail{
			width: 1182px;
			height: 630px;
			margin: 0 auto;
			padding-top: 76px;
			.title-en{
				width: 1182px;
				height: 60px;
				padding-top: 34px;
				background: url('./financing/procedure.png') no-repeat center;
				text-align: center;
				font-size: 55px;
				font-weight: 800;
			}
			.line{
				text-align: center;
				padding-top: 20px;
			}
			.process-map{
				width: 1182px;
				padding-top: 100px;
				height: 220px;
				li{
					float: left;
					height: 220px;
					p{
						color: #333333;
						font-size: 30px;
						line-height: 35px;
						height: 35px;
						&.top{
							padding-top: 20px;
						}
					}
					&.item{
						width: 340px;
						text-align: center;
					}
					&.left{
						text-align: left;
					}
					&.arrow{
						width: 80px;
						img{
							margin-top: 30px;
						}
					}
				}
			}
			.down-load{
				display: inline-block;
				width: 155px;
				height: 60px;
				line-height: 60px;
				box-sizing: border-box;
				text-align: center;
				color: #0587FF;
				font-size: 22px;
				border: 1px solid #0587FF;
				border-radius: 30px;
				margin-top: 20px;
			}
		}
	}
	.contact-us{
		width: 100%;
		height: 644px;
		background-color: #f7f7f7;
		.contact-detail{
			width: 1182px;
			height: 520px;
			padding-top: 124px;
			margin: 0 auto;
			.title-en{
				width: 1182px;
				height: 60px;
				padding-top: 34px;
				background: url('./financing/contact-us.png') no-repeat center;
				text-align: center;
				font-size: 55px;
				font-weight: 800;
			}
			.line{
				text-align: center;
				padding-top: 20px;
			}
			.more-detail{
				width: 1182px;
				height: 218px;
				padding-top: 42px;
				li{
					width: 340px;
					height: 218px;
					float: left;
					background-color: #ffffff;
					&.left{
						text-align: center;
						font-size: 24px;
						color: #333333;
						p{
							padding-top: 35px;
							padding-bottom: 18px;
						}
						img{
							display: inline-block;
							width: 110px;
							height: 110px;
						}
					}
					&.middle{
						margin:0 81px;
					}
					&.middle,&.right{
						padding-left: 60px;
						width: 280px;
						p{
							font-size: 24px;
							color: #333333;
							padding-top: 32px;
							padding-bottom: 12px;
						}
						h2{
							font-size: 24px;
							color: #333333;
							padding-top: 52px;
						}
						span{
							margin-left:2px;
							display: inline-block;
							width: 14px;
							height: 5px;
							background-color: #106CE7;
						}
					}
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// financing.vue?0088d735